/**
 * Inline link that opens the risk methodology modal from inside the topic risk drawer.
 * The modal reads scroll navigation state, which the company page does not provide,
 * so it brings its own provider the same way TopicalRiskScene does.
 */
import { ScrollNavigationProvider } from '@app/src/context/ScrollNavigationContext'
import TopicalRiskMethodologyModal from '@app/src/pages/TopicalRisk/TopicalRiskMethodologyModal'
import { Link } from '@mui/material'
import React, { useState } from 'react'

export const MethodologySections = {
  TopicRisk: 'topicRisk',
} as const

export interface MethodologyLinkProps {
  children: React.ReactNode
  section?: string
}

export const MethodologyLink: React.FC<MethodologyLinkProps> = ({ children, section }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Link component="button" type="button" color="inherit" onClick={() => setIsModalOpen(true)}>
        {children}
      </Link>
      <ScrollNavigationProvider scrollMarginTopOffset={{ xs: 10, md: -34 }}>
        <TopicalRiskMethodologyModal
          open={isModalOpen}
          initialSection={section}
          onClose={() => setIsModalOpen(false)}
        />
      </ScrollNavigationProvider>
    </>
  )
}

export default MethodologyLink
